<nav class="sticky top-0 z-[900] w-full bg-white/95 backdrop-blur border-b border-slate-100">
  <div class="w-full px-4">
    <div class="flex items-center justify-between h-16 gap-3">
      <!-- Left: sidebar toggle + title -->
      <div class="flex items-center min-w-0 gap-3">
        <button
          type="button"
          (click)="sidebarToggle()"
          class="inline-flex items-center justify-center w-10 h-10 transition-colors rounded-xl hover:bg-slate-50 focus:outline-none "
          aria-label="Ouvrir le menu"
        >
          <span nz-icon nzType="menu" nzTheme="outline" class="text-slate-700"></span>
        </button>
        <div class="min-w-0">
          <div class="text-sm font-semibold truncate text-slate-800">
            {{ titleModule }}
          </div>
        </div>
      </div>

      <!-- Mobile: actions toggle -->
    <button
      type="button"
        (click)="toggleMobileMenu()"
        class="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-xl hover:bg-slate-50 transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2"
        aria-label="Ouvrir les actions"
    >
        <span nz-icon nzType="appstore" nzTheme="outline" class="text-slate-700"></span>
    </button>

      <!-- Right: actions (desktop) -->
      <div class="items-center hidden gap-3 lg:flex">
        <!-- Search with dropdown -->
        <div class="relative">
          <nz-input-group
            [nzPrefixIcon]="isSearching ? 'loading' : 'search'"
            class="custom-input-group w-[320px]"
            nzSize="large"
          >
            <input
              nz-input
              nzSize="large"
              placeholder="Rechercher une plainte..."
              type="search"
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchChange($event)"
              (focus)="onSearchFocus()"
              (keyup.enter)="onSearchSubmit()"
            />
          </nz-input-group>

          <!-- Search Results Dropdown -->
          <div
            *ngIf="showSearchResults"
            class="absolute top-full left-0 right-0 mt-1 bg-white rounded-xl shadow-lg border border-slate-200 max-h-[400px] overflow-y-auto z-[1000]"
          >
            <!-- Loading state -->
            <div *ngIf="isSearching" class="p-4 text-center">
              <span nz-icon nzType="loading" class="text-2xl text-slate-400"></span>
              <p class="mt-2 text-sm text-slate-500">Recherche en cours...</p>
            </div>

            <!-- Empty state -->
            <div *ngIf="!isSearching && searchResults.length === 0" class="p-4 text-center">
              <span nz-icon nzType="search" class="text-3xl text-slate-300"></span>
              <p class="mt-2 text-sm text-slate-500">Aucun résultat trouvé</p>
            </div>

            <!-- Results list -->
            <div *ngIf="!isSearching && searchResults.length > 0">
              <div class="px-3 py-2 text-xs font-medium border-b text-slate-500 bg-slate-50 border-slate-100">
                {{ searchResults.length }} résultat(s) trouvé(s)
              </div>
              <div
                *ngFor="let result of searchResults"
                (click)="goToComplaintDetails(result.id)"
                class="px-4 py-3 transition-colors border-b cursor-pointer hover:bg-slate-50 border-slate-100 last:border-b-0"
              >
                <div class="flex items-center justify-between gap-2">
                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-2 mb-1">
                      <nz-tag *ngIf="result.anonymous" nzColor="default" class="!m-0 !text-xs">Anonyme</nz-tag>
                      <nz-tag *ngIf="!result.anonymous" nzColor="success" class="!m-0 !text-xs">Identifié</nz-tag>
                      <span class="text-xs text-slate-400">{{ result.createdAt | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <p class="text-sm font-medium truncate text-slate-800">
                      {{ result.trackingCode || 'N/A' }}
                    </p>
                    <p class="text-xs truncate text-slate-500">
                      {{ result.factsPlace || 'Lieu non spécifié' }}
                    </p>
                  </div>
                  <span nz-icon nzType="right" class="text-slate-400"></span>
                </div>
              </div>
            </div>
          </div>

          <!-- Backdrop to close dropdown -->
          <div
            *ngIf="showSearchResults"
            class="fixed inset-0 z-[999]"
            (click)="closeSearchResults()"
          ></div>
        </div>



        <div
          nz-dropdown
          [(nzVisible)]="userMenuVisible"
          [nzDropdownMenu]="userMenu"
          nzTrigger="click"
          nzPlacement="bottomRight"
          type="button"
          class="flex items-center gap-2 py-2 pl-2 pr-3 transition-colors bg-white rounded-xl hover:bg-slate-50 focus:outline-none focus:ring-offset-2"
        >
          <nz-avatar
            [nzText]="getInitials()"
            [nzSize]="36"
            class="!bg-[var(--primary-color)] !text-white"
            style="font-weight: 700; font-size: 14px;"
          ></nz-avatar>
          <span class="text-sm font-medium text-slate-700">
            {{ profile?.lastName }} {{ profile?.firstName }}
          </span>
          <span nz-icon nzType="down" nzTheme="outline" class="text-xs text-slate-500"></span>
        </div>
        <nz-dropdown-menu #userMenu="nzDropdownMenu">
          <ul nz-menu class="min-w-[220px] rounded-xl border border-slate-100 shadow-lg py-1">
            <li nz-menu-item (click)="goProfile()">
              <span nz-icon nzType="user" nzTheme="outline" class="mr-2 text-slate-600"></span>
              Mon profil
            </li>
            <li nz-menu-item (click)="openChangePasswordModal()">
              <span nz-icon nzType="lock" nzTheme="outline" class="mr-2 text-slate-600"></span>
              Modifier le mot de passe
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="onLogOut()" [style.color]="'var(--neutral-strong)'">
              <span nz-icon nzType="logout" nzTheme="outline" class="mr-2" [style.color]="'var(--neutral-strong)'"></span>
              Se déconnecter
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>

    <!-- Breadcrumb -->
    <div class="pb-3">
      <nz-breadcrumb nzAutoGenerate nzSeparator="/"></nz-breadcrumb>
    </div>
  </div>

  <!-- Mobile panel -->
  @if (isMobileMenuOpen) {
  <div class="bg-white border-t lg:hidden border-slate-100">
    <div class="p-4 space-y-3">
      <!-- Mobile search with dropdown -->
      <div class="relative">
        <nz-input-group
          [nzPrefixIcon]="isSearching ? 'loading' : 'search'"
          class="w-full custom-input-group"
          nzSize="large"
        >
          <input
            nz-input
            nzSize="large"
            placeholder="Rechercher une plainte..."
            type="search"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange($event)"
            (focus)="onSearchFocus()"
            (keyup.enter)="onSearchSubmit()"
          />
        </nz-input-group>

        <!-- Mobile Search Results Dropdown -->
        <div
          *ngIf="showSearchResults"
          class="absolute top-full left-0 right-0 mt-1 bg-white rounded-xl shadow-lg border border-slate-200 max-h-[300px] overflow-y-auto z-[1000]"
        >
          <!-- Loading state -->
          <div *ngIf="isSearching" class="p-4 text-center">
            <span nz-icon nzType="loading" class="text-2xl text-slate-400"></span>
            <p class="mt-2 text-sm text-slate-500">Recherche en cours...</p>
          </div>

          <!-- Empty state -->
          <div *ngIf="!isSearching && searchResults.length === 0" class="p-4 text-center">
            <span nz-icon nzType="search" class="text-3xl text-slate-300"></span>
            <p class="mt-2 text-sm text-slate-500">Aucun résultat trouvé</p>
          </div>

          <!-- Results list -->
          <div *ngIf="!isSearching && searchResults.length > 0">
            <div class="px-3 py-2 text-xs font-medium border-b text-slate-500 bg-slate-50 border-slate-100">
              {{ searchResults.length }} résultat(s) trouvé(s)
            </div>
            <div
              *ngFor="let result of searchResults"
              (click)="goToComplaintDetails(result.id); closeMobileMenu()"
              class="px-4 py-3 border-b cursor-pointer hover:bg-slate-50 border-slate-100 last:border-b-0"
            >
              <div class="flex items-center justify-between gap-2">
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <nz-tag *ngIf="result.anonymous" nzColor="default" class="!m-0 !text-xs">Anonyme</nz-tag>
                    <nz-tag *ngIf="!result.anonymous" nzColor="success" class="!m-0 !text-xs">Identifié</nz-tag>
                    <span class="text-xs text-slate-400">{{ result.createdAt | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <p class="text-sm font-medium truncate text-slate-800">
                    {{ result.trackingCode || 'N/A' }}
                  </p>
                  <p class="text-xs truncate text-slate-500">
                    {{ result.factsPlace || 'Lieu non spécifié' }}
                  </p>
                </div>
                <span nz-icon nzType="right" class="text-slate-400"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between">


        <button
          nz-dropdown
          [(nzVisible)]="userMenuMobileVisible"
          [nzDropdownMenu]="userMenuMobile"
          nzTrigger="click"
          nzPlacement="bottomRight"
          type="button"
          class="flex items-center gap-2 py-2 pl-2 pr-3 transition-colors bg-white rounded-xl hover:bg-slate-50"
        >
          <nz-avatar
            [nzText]="getInitials()"
            [nzSize]="36"
            class="!bg-[var(--primary-color)] !text-white"
            style="font-weight: 700; font-size: 14px;"
          ></nz-avatar>
          <span class="text-sm font-medium text-slate-700">
            {{ profile?.lastName }} {{ profile?.firstName }}
          </span>
          <span nz-icon nzType="down" nzTheme="outline" class="text-xs text-slate-500"></span>
        </button>
        <nz-dropdown-menu #userMenuMobile="nzDropdownMenu">
          <ul nz-menu class="min-w-[220px] rounded-xl border border-slate-100 shadow-lg py-1">
            <li nz-menu-item (click)="goProfile(); closeMobileMenu()">
              <span nz-icon nzType="user" nzTheme="outline" class="mr-2 text-slate-600"></span>
              Mon profil
            </li>
            <li nz-menu-item (click)="openChangePasswordModal(); closeMobileMenu()">
              <span nz-icon nzType="lock" nzTheme="outline" class="mr-2 text-slate-600"></span>
              Modifier le mot de passe
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="onLogOut(); closeMobileMenu()" [style.color]="'var(--neutral-strong)'">
              <span nz-icon nzType="logout" nzTheme="outline" class="mr-2" [style.color]="'var(--neutral-strong)'"></span>
              Se déconnecter
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
  }
</nav>
